import React from 'react';
import { Link } from 'react-router-dom';

export const BrandServicesSection: React.FC = () => {
  const brands = [
    {
      name: 'Samsung',
      icon: 'ri-smartphone-line',
      color: 'from-blue-500 to-blue-700',
      description: 'Galaxy series repair with genuine Samsung parts',
      link: '/samsung-service',
      image: '/assets/samsung-brand.jpg'
    },
    {
      name: 'Apple',
      icon: 'ri-apple-line',
      color: 'from-gray-600 to-gray-800',
      description: 'iPhone repair with certified Apple components',
      link: '/apple-service',
      image: '/assets/apple-brand.jpg'
    },
    {
      name: 'Google Pixel',
      icon: 'ri-google-line',
      color: 'from-green-500 to-blue-600',
      description: 'Pixel device repair with original Google parts',
      link: '/google-pixel-service',
      image: '/assets/pixel-brand.jpg'
    },
    {
      name: 'OnePlus',
      icon: 'ri-smartphone-line',
      color: 'from-red-500 to-red-700',
      description: 'OnePlus repair with authentic spare parts',
      link: '/oneplus-service',
      image: '/assets/oneplus-brand.jpg'
    },
    {
      name: 'Vivo',
      icon: 'ri-smartphone-line',
      color: 'from-purple-500 to-indigo-600',
      description: 'Vivo mobile repair with genuine components',
      link: '/vivo-service',
      image: '/assets/vivo-brand.jpg'
    },
    {
      name: 'Realme',
      icon: 'ri-smartphone-line',
      color: 'from-yellow-500 to-orange-600',
      description: 'Realme device repair with original parts',
      link: '/realme-service',
      image: '/assets/realme-brand.jpg'
    },
    {
      name: 'Motorola',
      icon: 'ri-smartphone-line',
      color: 'from-blue-600 to-indigo-700',
      description: 'Motorola repair with certified spare parts',
      link: '/motorola-service',
      image: '/assets/motorola-brand.jpg'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Brand-Specific Repair Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in repairing all major smartphone brands with genuine parts, 
            certified technicians, and comprehensive warranty coverage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {brands.map((brand, index) => (
            <Link
              key={index}
              to={brand.link}
              className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={brand.image}
                  alt={`${brand.name} repair service`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${brand.color} opacity-80 group-hover:opacity-70 transition-opacity`}></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center text-white">
                    <i className={`${brand.icon} text-4xl mb-2`}></i>
                    <h3 className="text-xl font-bold">{brand.name}</h3>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {brand.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <span className="text-blue-600 font-semibold group-hover:text-blue-700 transition-colors">
                    Learn More
                  </span>
                  <i className="ri-arrow-right-line text-blue-600 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};